export default [
    {
        title: "mainmenu.status",
        icon: "heart-rate",
        class: "d-none d-sm-block",
        href: "https://status.saysimple.com",
        resource: "status",
        action: "read",
    },
];
